module.exports = __webpack_public_path__ + "img/just-logo.b203c46c.png";